import PropTypes from "prop-types";
import React, { useEffect } from "react";

const CountdownCircle = ({ delayMS, handleCountdownEnd }) => {
    const styles = {
        animationDuration: `${delayMS}ms`,
    };

    useEffect(() => {
        const timeout = setTimeout(handleCountdownEnd, delayMS);
        return () => clearTimeout(timeout);
    }, [delayMS]);

    // https://codepen.io/carsy/pen/VvqJwm
    return (
        <div className="countdown">
            <svg className="countdown__svg">
                <circle
                    key={delayMS}
                    className="countdown__circle"
                    r="18"
                    cx="20"
                    cy="20"
                    style={styles}
                />
            </svg>
        </div>
    );
};

CountdownCircle.propTypes = {
    delayMS: PropTypes.number,
    handleCountdownEnd: PropTypes.func,
};

CountdownCircle.defaultProps = {
    delayMS: 5000,
    handleCountdownEnd: () => {},
};

export default CountdownCircle;
